import Totals from "../../crew/Totals";
import BigNum from "../../math/BigNum";
import NumberValue from "../../value/NumberValue";
import SkillNode from "../SkillNode";
import SkillNodePurchaseListener from "../SkillNodePurchaseListener";

export default class NumberValueSkillNode extends SkillNode {
    /**
     * @param {string} id 
     * @param {string} title 
     * @param {string} description 
     * @param {Totals} totals
     * @param {string} iconFileName 
     * @param {BigNum} cost 
     * @param {SkillNodePurchaseListener} purchaseListener
     * @param {number} valuePerSkillLevel
     * @param {NumberValue} numberValue
     */
    constructor(id, title, description, totals, iconFileName, cost, purchaseListener, valuePerSkillLevel, numberValue) {
        super(id, title, description, totals, iconFileName, cost, purchaseListener);
        /**
         * @constant
         * @type {number}
         */
        this.valuePerSkillLevel = valuePerSkillLevel;

        /**
         * @constant
         * @type {NumberValue}
         */
        this.numberValue = numberValue;
    }

    /**
     * @override
     */
    onPurchase() {
        if (super.onPurchase()) {
            this.numberValue.incrementValue(this.valuePerSkillLevel);
            return true;
        }
        else {
            return false;
        }
    }

    /**
     * @override
     */
    onPurchaseFromSave() {
        this.numberValue.incrementValue(this.valuePerSkillLevel);
        super.onPurchaseFromSave();
    }

    ////////////////////////////////////
    // GameModel
    ////////////////////////////////////

    /**
     * @override
     */
    resetFull() {
        super.resetFull();
        this.numberValue.reset();
    }
}